export const PAGE_SIZE = 14;
export const DEFAULT_PAGE_SIZE = 15;
export const GET_CAMPAIGN_DEFAULT_PAGE_SIZE = 18
export const GET_BRAND_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_CATEGORY_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_GENERAL_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_TEMPLATE_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_STATIC_HTML_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_IMAGE_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_PRODUCT_BLOCK_DEFAULT_PAGE_SIZE = 16
// export const GET_STATIC_HTML_BLOCK_DEFAULT_PAGE_SIZE = 16
export const GET_FBTS_DEFAULT_PAGE_SIZE = 17
export const GET_FAQ_DEFAULT_PAGE_SIZE = 16
export const GET_PLA_FEED_DEFAULT_SIZE = 16
export const GET_ATTRIBUTE_DEFAULT_PAGE_SIZE = 10
export const GET_QNA_DEFAULT_SIZE = 8;
export const GET_SERVICEABILITY_DEFAULT_SIZE = 15;
export const GET_PART_PAYMENT_DEFAULT_SIZE = 15;
export const GET_REVIEWS_DEFAULT_SIZE = 10;
export const GET_AI_DEFAULT_PAGE_SIZE = 5;
export const GET_PAGEMAPPING_DEFAULT_PAGE_SIZE = 10
export const GET_ARTICLE_PAGE_SIZE = 10
export const GET_DYNAMIC_PRICING_DEFAULT_PAGE_SIZE = 15;
export const GET_SHIPPING_PORTAL_DEFAULT_PAGE_SIZE = 15;

export const CAMPAIGN_SECTION_TYPES = {
    "BANNER_AD_UNIT": "BANNER_AD_UNIT",
    "FEATURED_PRODUCT_UNIT": "FEATURED_PRODUCT_UNIT",
    "PROMOTED_BRAND_UNIT": "PROMOTED_BRAND_UNIT",
    "VIDEO_UNIT": "VIDEO_UNIT"
}
export const CAMPAIGN_TYPES = {
    "BRAND_BASED_CAMPAIGN": "BRAND_BASED_CAMPAIGN",
    "CATEGORY_BASED_CAMPAIGN": "CATEGORY_BASED_CAMPAIGN",
    "BRAND_CATEGORY_BASED_CAMPAIGN": "BRAND_CATEGORY_BASED_CAMPAIGN",
    "MSNS_BASED_CAMPAIGN": "MSNS_BASED_CAMPAIGN",
    "ORDER_CONFIRMATION_PAGE_CAMPAIGN": "ORDER_CONFIRMATION_PAGE_CAMPAIGN",
    "PRODUCT_BASED_CAMPAIGN": "PRODUCT_BASED_CAMPAIGN",
    "HOME_PAGE_ONSCROLL_ADUNIT": "HOME_PAGE_ONSCROLL_ADUNIT",
    "PDP_SPONSORED_ADUNIT": "PDP_SPONSORED_ADUNIT"
}

export const CREATE_CAMPAIGN_FORM_ERRORS = {
    "INVALID_FILE_DIMENSION": "Invalid Dimension, Kindly provide a banner of size ",
    "INVALID_FILE_SIZE": "Invalid Size, Kindly provide a banner of size less than ",
    "INVALID_LANDING_PAGE_URL_STAGING": "Invalid url, kindly provide a url which starts with https://",
    "INVALID_LANDING_PAGE_URL_PRODUCTION": "Invalid url, kindly provide a url which starts with https://",
    "INVALID_YOUTUBE_URL": "Invalid url, Kindly provide valid youtube url",
    "NOT_ABLE_TO_SAVE_CAMPAIGN_KINDLY_CHECK_FOR_ERRORS": "Not able to save campaign, Kindly check for errors",
    "PLEASE_SELECT_PLATFORM": "Please select platform",
    "PLEASE_ADD_CAMPAIGN_NAME": "Please add campaign name",
    "PLEASE_SELECT_START_DATE": "Please select start date",
    "PLEASE_SELECT_END_DATE": "Please select end date",
    "PLEASE_FILL_CURRENT_BANNER_DETAILS": "Please fill current banner details"
}

export const CAMPAIGN_FILE_DIMENSION_CONFIG: any = {
    PWA: {
        "INLINE_RECTANGLE_THANKYOUPAGE_POSITION_1": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_THANKYOUPAGE_POSITION_2": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_THANKYOUPAGE_POSITION_3": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PLP_POSITION_1": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PLP_POSITION_2": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PLP_POSITION_3": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PLP_POSITION_1": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PLP_POSITION_2": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PLP_POSITION_3": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_1": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_2": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_3": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_4": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_5": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PDP": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PDP": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "PROMOTED_BRAND_UNIT": {
            allowedDimensions: ["125 * 125"],
            maxFileSizeInKb: 500
        }
    },
    DESKTOP: {
        "DESKTOP_INLINE_RECTANGLE_THANKYOUPAGE_POSITION_1": {
            allowedDimensions: ["336 * 280", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "DESKTOP_INLINE_RECTANGLE_THANKYOUPAGE_POSITION_2": {
            allowedDimensions: ["336 * 280", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "DESKTOP_INLINE_RECTANGLE_THANKYOUPAGE_POSITION_3": {
            allowedDimensions: ["336 * 280", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "INLINE_RECTANGLE_PLP": {
            allowedDimensions: ["336 * 280", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "DESKTOP_LEADERBOARD_PLP_POSITION_1": {
            allowedDimensions: ["728 * 90", "970 * 90", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "DESKTOP_LEADERBOARD_PLP_POSITION_2": {
            allowedDimensions: ["728 * 90", "970 * 90", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "DESKTOP_LEADERBOARD_PDP": {
            allowedDimensions: ["728 * 90", "970 * 90", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "TOP_BANNER_POSITION_1": {
            allowedDimensions: ["1079 * 230", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "TOP_BANNER_POSITION_2": {
            allowedDimensions: ["1079 * 230", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "TOP_BANNER_POSITION_3": {
            allowedDimensions: ["1079 * 230", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "TOP_BANNER_POSITION_4": {
            allowedDimensions: ["1079 * 230", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "TOP_BANNER_POSITION_5": {
            allowedDimensions: ["1079 * 230", "1500 * 230"],
            maxFileSizeInKb: 600
        },
        "PROMOTED_BRAND_UNIT": {
            allowedDimensions: ["264 * 186", "1500 * 230"],
            maxFileSizeInKb: 500
        }
    },
    APP: {
        "INLINE_RECTANGLE_THANKYOUPAGE_POSITION_1": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_THANKYOUPAGE_POSITION_2": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_THANKYOUPAGE_POSITION_3": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PLP_POSITION_1": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PLP_POSITION_2": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PLP_POSITION_3": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PLP_POSITION_1": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PLP_POSITION_2": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PLP_POSITION_3": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_1": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_2": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_3": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_4": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "TOP_BANNER_POSITION_5": {
            allowedDimensions: ["375 * 180"],
            maxFileSizeInKb: 500
        },
        "INLINE_RECTANGLE_PDP": {
            allowedDimensions: ["300 * 250"],
            maxFileSizeInKb: 500
        },
        "MOBILE_LEADERBOARD_PDP": {
            allowedDimensions: ["320 * 50"],
            maxFileSizeInKb: 500
        },
        "PROMOTED_BRAND_UNIT": {
            allowedDimensions: ["125 * 125"],
            maxFileSizeInKb: 500
        }
    }
}

export const PLATFORMS = [
    {
        "title": "APP",
        "value": "app"
    },
    {
        "title": "DESKTOP",
        "value": "desktop"
    },
    {
        "title": "MOBILE",
        "value": "mobile"
    },
    {
        "title": "PWA",
        "value": "pwa"
    }]

export const CAMPAIGN_FILE_DIMENSION_CONFIG_UI = {
    "PWA": [{
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp_position_1",
        "dimension": ["300 * 250"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "mobile_leaderboard_plp_position_1",
        "dimension": ["320 * 50"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp_position_2",
        "dimension": ["300 * 250"]
    }, {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "mobile_leaderboard_plp_position_2",
        "dimension": ["320 * 50"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp_position_3",
        "dimension": ["300 * 250"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "mobile_leaderboard_plp_position_3",
        "dimension": ["320 * 50"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "top_banner_<position no.>",
        "dimension": ["375 * 180"]
    },
    {
        "pageType": "PDP",
        "bannerName": "inline_rectangle_pdp",
        "dimension": ["300 * 250"]
    },
    {
        "pageType": "PDP",
        "bannerName": "mobile_leaderboard_pdp",
        "dimension": ["320 * 50"]
    }],
    "DESKTOP": [{
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp",
        "dimension": ["336 * 280", "1500 * 230"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "desktop_leaderboard_plp_position_1",
        "dimension": ["728 * 90", "970 * 90", "1500 * 230"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "desktop_leaderboard_plp_position_2",
        "dimension": ["728 * 90", "970 * 90", "1500 * 230"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "top_banner_<position no.>",
        "dimension": ["1079 * 230", "1500 * 230"]
    },
    {
        "pageType": "PDP",
        "bannerName": "desktop_leaderboard_pdp",
        "dimension": ["728 * 90", "970 * 90", "1500 * 230"]
    }],
    "APP": [{
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp_position_1",
        "dimension": ["300 * 250"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "mobile_leaderboard_plp_position_1",
        "dimension": ["320 * 50"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp_position_2",
        "dimension": ["300 * 250"]
    }, {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "mobile_leaderboard_plp_position_2",
        "dimension": ["320 * 50"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "inline_rectangle_plp_position_3",
        "dimension": ["300 * 250"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "mobile_leaderboard_plp_position_3",
        "dimension": ["320 * 50"]
    },
    {
        "pageType": "Brand+Brand Category+PLP",
        "bannerName": "top_banner_<position no.>",
        "dimension": ["375 * 180"]
    },
    {
        "pageType": "PDP",
        "bannerName": "inline_rectangle_pdp",
        "dimension": ["300 * 250"]
    },
    {
        "pageType": "PDP",
        "bannerName": "mobile_leaderboard_pdp",
        "dimension": ["320 * 50"]
    }]
}

export const WHATSAPP_CAMPAIGN_TYPES = {
    "DELAY_COMMUNICATION": "DELAY_COMMUNICATION",
    "SUPPLIER_SUPPORT": "SUPPLIER_SUPPORT"
}

export const AI_POWERED_TYPES = {
    "GENERATE_PRODUCT_DESCRIPTION": "GENERATE_PRODUCT_DESCRIPTION"
}

export const MODULES = {
    ADSENSE_CAMPAIGN: "ADSENSE_CAMPAIGN",
    BLOCK_CUSTOMER: "BLOCK_CUSTOMER",
    FBT: "FBT",
    LAYOUT: "LAYOUT",
    FAQ: "FAQ",
    REVIEW: "REVIEW",
    WHATSAPP_CAMPAIGN: "WHATSAPP_CAMPAIGN",
    AI_POWERED: "AI_POWERED",
    ATTRIBUTE_LISTING: "ATTRIBUTE_LISTING",
    QNA: "QNA",
    USER_MANAGEMENT: "USER_MANAGEMENT",
    PRODUCT_TAGGING: "PRODUCT_TAGGING",
    SERVICEABILITY: "SERVICEABILITY",
    PLA_FEED: "PLA_FEED",
    CACHE_DELETE: "CACHE_DELETE",
    PAGE_MAPPING: "PAGE_MAPPING",
    ARTICLE: "ARTICLE",
    BLOCKS: "BLOCKS",
    URL_SHORTENER: "URL_SHORTENER",
    PROMOCODE_LIST: "PROMOCODE_LIST",
    FILE_UPLOADER: "FILE_UPLOADER",
    PRODUCT_PRICING: "PRODUCT_PRICING",
    ORDER_CHATBOT_ANALYTICS: "ORDER_CHATBOT_ANALYTICS",
    PAYMENT_MODE_MANAGEMENT: "PAYMENT_MODE_MANAGEMENT",
    PROMPT_MANAGEMENT: "PROMPT_MANAGEMENT",
    WHATSAPP_CHATBOT_ANALYTICS: "WHATSAPP_CHATBOT_ANALYTICS",
    PRODUCT_CHATBOT_ANALYSIS: "PRODUCT_CHATBOT_ANALYSIS",
    CRM: "CRM",
    STOCK_ALERT: "STOCK_ALERT",
    OCR: "OCR",
    OTP_ANALYTICS: "OTP_ANALYTICS",
    GENAI_COST_ANALYTICS: "GENAI_COST_ANALYTICS",
    DYNAMIC_PRICING: "DYNAMIC_PRICING",
    WARRANTY_SERVICE_APP: "WARRANTY_SERVICE_APP",
    PART_PAYMENT: "PART_PAYMENT",
    SHIPPING_PORTAL: "SHIPPING_PORTAL"
}

export const CRM_ADMIN_ROLE = "CRM_ADMIN";

export const CRM_SUBMODULES = {
    DASHBOARD: "CRM_DASHBOARD",
    OZONETEL_DASHBOARD: "CRM_OZONETEL_DASHBOARD",
    AGENT_PERFORMANCE: "CRM_AGENT_PERFORMANCE",
    ESCALATIONS: "CRM_ESCALATIONS",
    CALL_TRACK: "CRM_CALL_TRACK",
    CUSTOMERS: "CRM_CUSTOMERS",
    FRESHDESK_TICKETS: "CRM_FRESHDESK_TICKETS",
    INTERACTION_TIMELINE: "CRM_INTERACTION_TIMELINE",
    SAMAIRA_RFQ_CALLS: "CRM_SAMAIRA_RFQ_CALLS",
    AI_CALL_SIMULATOR: "CRM_AI_CALL_SIMULATOR",
    DEV_TOOLKIT_TRACE: "CRM_DEV_TOOLKIT_TRACE",
} as const;

export type CrmSubmodule = (typeof CRM_SUBMODULES)[keyof typeof CRM_SUBMODULES];


export const hasCrmSubAccess = (
    roles: string[] | undefined,
    submodule: CrmSubmodule
): boolean => {
    if (process.env.REACT_APP_ENVIRONMENT === "DEVELOPMENT") return true;
    if (!roles || !roles.length) return false;
    return (
        roles.includes("Super Admin") ||
        roles.includes(MODULES.CRM) ||
        roles.includes(CRM_ADMIN_ROLE) ||
        roles.includes(submodule)
    );
};

export const LAYOUT_PAGE_HEADERS = [
    'ID',
    'Layout Name',
    'Platform',
    'Created by',
    'Created At',
    'Updated At',
    'Status',
    'Action'
];

export const REVIEW_PAGE_HEADERS = [
    'ID',
    'MSN',
    'User',
    'Rating',
    'Review Subject',
    'Review Text',
    'Enabled',
    'Approved',
    // 'Images',
    // 'Videos',
    'Created At Modified At',
    'Action'
]

export const SERVICEABLITY_PAGE_HEADERS = [
    'Msn',
    'Category',
    'ZipCode',
    'Serviceable',
    'Cod',
    'Created At',
    'Updated At'
];

export const PART_PAYMENT_PAGE_HEADERS = [
    'Msn',
    'Part Payment',
    'Created At',
    'Updated At',
    'Updated By'
];

export const DYNAMIC_PRICING_PAGE_HEADERS = [
    'MSN',
    'Name',
    'Category',
    'Competitor',
    'Status',
    'Min GM%',
    'Max GM%',
    'Action'
];

export const PAGE_MODES = {
    "VIEW": "VIEW",
    "CREATE": "CREATE",
    "EDIT": "EDIT"
}
